import { Action, LandlordBuilding } from '@root/types';
import normalize from '@shared/normalize';

export type SavedBuildingsStoreState = Record<string, boolean | LandlordBuilding | {}>;

export const defaultState = { byId: {} };

export default function savedBuildingsReducer(
  state: SavedBuildingsStoreState = defaultState,
  action: Action,
) {
  switch (action.type) {
    case 'RECEIVE_UNSAVED_BUILDING':
    case 'RECEIVE_SAVED_BUILDING': {
      return {
        ...state,
        [action.payload.buildingId]: action.payload.saved,
      };
    }
    case 'RECEIVE_SAVED_BUILDINGS':
      return {
        ...state,
        byId: normalize(action.payload.buildings),
      };
    default:
      return state;
  }
}
